import React, { PropTypes } from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import BCReactComponent from '@bibliocommons/base-bc-react-component';
import SortDropDown from '@bibliocommons/sort-dropdown';
import { PrintButton } from '@bibliocommons/print';
import UtilityBar from '../../../shared/UtilityBar';
import Pagination from '@bibliocommons/pagination';
import { childrenShape } from '@bibliocommons/bc-prop-types';

import './BorrowingUtilityBar.scss';

export default class BorrowingUtilityBar extends BCReactComponent {
  renderBottomRow() {
    const { pagination, sortOptions, printURL, isFetching } = this.props;

    if (pagination || sortOptions) {
      return (
        <div className="bottom-row">
          {sortOptions && <SortDropDown options={sortOptions} />}
          <div>
            {pagination && <Pagination
              autoFocus
              isFetching={isFetching || false}
              page={pagination.get('page')}
              limit={pagination.get('limit')}
              count={pagination.get('count')}
              pages={pagination.get('pages')} /> }
            {printURL && <PrintButton url={printURL} />}
          </div>
        </div>
      );
    }

    return null;
  }

  renderSortRow() {
    const { sortOptions } = this.props;
    return sortOptions && (
      <div className="sort-row visible-sm visible-xs">
        <SortDropDown options={sortOptions} />
      </div>
    );
  }

  render() {
    const className = cn('cp-borrowing-utility-bar', this.props.className);
    return (
      <UtilityBar className={className}>
        <div className="top-row">
          {this.props.title}
        </div>
        {this.renderSortRow()}
        {this.renderBottomRow()}
      </UtilityBar>
    );
  }
}

BorrowingUtilityBar.propTypes = {
  isFetching: PropTypes.bool,
  sortOptions: ImmutablePropTypes.list,
  pagination: ImmutablePropTypes.map,
  title: childrenShape,
  renderPagination: PropTypes.func,
  printURL: PropTypes.string,
  className: PropTypes.string
};



// WEBPACK FOOTER //
// ./app/components/borrowing/shared/BorrowingUtilityBar/BorrowingUtilityBar.jsx